import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from "@angular/core"
import { FormControl, FormGroup } from "@angular/forms"
import { Product } from "src/app/meta/Product.interface"
import { environment } from "src/environments/environment"

@Component({
  selector: "ow-base-product",
  templateUrl: "./base-product.component.html"
})
export class BaseProductComponent implements OnInit, OnDestroy {
  @Input() product: Product | null = null
  @Input() variantContractTimeProducts: Product[] = []
  @Output() choose = new EventEmitter<Product>()

  public includedProducts = signal<Product[]>([])
  public regularBaseFee = signal<number>(0)
  public pibHref: string | null = null

  public form = new FormGroup({
    variantContractTimeProductId: new FormControl<number>(0)
  })

  private readonly subscriptions = [
    this.form.controls.variantContractTimeProductId.valueChanges.subscribe(() => {
      this.updateIncludedProducts()
      this.calcFee()
      this.updatePibHref()
    })
  ]

  ngOnInit(): void {
    this.form.controls.variantContractTimeProductId.setValue(this.product!.productId)
    this.updateIncludedProducts()
    this.calcFee()
    this.updatePibHref()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private updatePibHref(): void {
    const product = this.getSelectedProduct()
    this.pibHref = `${environment.assetsUrl}/templates/pib_${product.marketingInformation.speedDown}_${product.marketingInformation.contractTime}_business.pdf`
  }

  public chooseProduct(): void {
    this.choose.emit(this.getSelectedProduct())
  }

  public getSelectedProduct(): Product {
    if (this.form.controls.variantContractTimeProductId.value === this.product?.productId) {
      return this.product
    }
    return this.variantContractTimeProducts.find((product) => product.productId === this.form.controls.variantContractTimeProductId.value)!
  }

  private updateIncludedProducts(): void {
    this.includedProducts.set(this.getSelectedProduct().includedProducts.filter((product) =>
      product.hasOwnProperty("labels")
      && Array.isArray(product.labels)
      && product.labels.indexOf("showInBundle") >= 0
    ))
  }

  private calcFee(): void {
    const baseFeeProducts = this.getSelectedProduct().includedProducts.filter((product) =>
      product.hasOwnProperty("labels")
      && Array.isArray(product.labels)
      && product.labels.indexOf("Basisprodukt") >= 0
      && product.labels.indexOf("Internet") >= 0
      && product.hasOwnProperty("marketingInformation")
      && typeof product.marketingInformation.recurringMonthlyFee === "number"
      && product.marketingInformation.recurringMonthlyFee > 0
    )
    if (baseFeeProducts.length > 0) {
      this.regularBaseFee.set(baseFeeProducts[0].marketingInformation.recurringMonthlyFee)
    } else {
      this.regularBaseFee.set(0)
    }
  }

}
